
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Import Memory Card Template

    <button  mat-stroked-button class="mr-5" color="primary"
       matTooltip="Add Memory Card" (click)="addMemoryCard()">
       <mat-icon>add</mat-icon> Memory Card
    </button>    
   
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select (selectionChange)="OnSelectCategoryImportTemp($event)" value="My Template">
          <mat-option value="My Template">Template</mat-option>
          <mat-option value="Organization">Organization</mat-option>
          <mat-option value="Global">Global</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="list" #categoryList>
        <ul>
          <li (click)="getThroughCategoryForQualifyingTempImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">
            All
          </li>
          <ng-container *ngFor="let stat of filteredQualifyingCategoryList; let i = index">
            <li (click)="getThroughCategoryForQualifyingTempImport(stat.templateCategoryID, i+1)"
              [ngClass]="{'active': currentIndex == i+1 }"> {{ stat.templateCategoryName }}</li>
          </ng-container>
        </ul>

      </div>

    </div>
    <div class="right">

      <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" width="100%">
            <tr>
              <th>Template Name</th>
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of QualifyingTemplatesList"
              [ngClass]="{ 'active': template.memoryCardID === memoryCardID}"
              [ngStyle]="{ 'background-color': template.memoryCardID === memoryCardID ? '#e8f0fe' : 'transparent' }">

              <td class="formName">
                {{template.memoryCardName}}
              </td>

              <td>
                <button mat-stroked-button color="primary"
                  (click)="SelectTemplateQuestionTempForImport(template)">Select</button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundQuestionTemplate" class="noRecordFound">No Record Found</div>
        </div>

      </div>

    </div>
  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeDialog()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="memoryCardID!=0"
      (click)="importQualifyingTemplates()">
      Import
    </button>
  </mat-dialog-actions>


